/**
 * Sends the app's active language to the API (Accept-Language header), so
 * the server answers in the same language (server/i18n). Wraps window.fetch
 * once, so it covers every API request - also raw fetch() calls and the
 * offline sync. Install it before the other fetch wrappers (main.jsx), so it
 * sits underneath them and also sees the requests they send.
 */
import i18n from ".";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:5001";
const apiOrigin = new URL(API_URL, window.location.origin).origin;

const isApiUrl = (value) => {
  try {
    const url = new URL(value, window.location.origin);
    return (
      url.origin === apiOrigin ||
      (url.origin === window.location.origin &&
        url.pathname.startsWith("/api/"))
    );
  } catch {
    return false;
  }
};

export const installApiLanguageHeader = () => {
  if (window.__flowmindLanguageHeaderInstalled) return;
  window.__flowmindLanguageHeaderInstalled = true;

  const nativeFetch = window.fetch.bind(window);

  window.fetch = (input, init) => {
    const isRequest = input instanceof Request;
    if (!isApiUrl(isRequest ? input.url : String(input))) {
      return nativeFetch(input, init);
    }

    // init.headers replaces a Request's own headers, so start from whichever
    // will be used (Headers, plain object or array of pairs)
    const headers = new Headers(
      init?.headers ?? (isRequest ? input.headers : undefined),
    );
    if (headers.has("Accept-Language")) return nativeFetch(input, init);

    headers.set("Accept-Language", i18n.resolvedLanguage || "en");
    return nativeFetch(input, { ...init, headers });
  };
};
